import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useState } from "react";
import "./style.scss"

const RawDatasetsTable = ({ dataTable }: { dataTable: Array<any> }) => {
  const [showPaginator, setShowPaginator] = useState<boolean>(false);

  const [dynamicColumns, setDynamicColumns] = useState<Array<any>>([]);
  const [scrollable, setScrollable] = useState<boolean>(false);
  const maxDatasetPerPage: number = 20;
  const maxCols: number = 4;

  useEffect(() => {
    let dynCols: Array<Element> = [];
    if (dataTable?.length > 0) {
      for (const [key, value] of Object.entries(dataTable[0])) {
        let col: any = <Column key={key} field={key} header={key} />;
        dynCols.push(col);
      }
      setDynamicColumns(dynCols);
    }
    if (dataTable?.length > maxDatasetPerPage) {
      setShowPaginator(true);
    } else setShowPaginator(false);
    if (dynCols.length > maxCols) {
      setScrollable(true);
    }
  }, [dataTable]);

  return (
    <div className="chartDiv">
      <DataTable
        value={dataTable}
        paginator={showPaginator}
        responsiveLayout="scroll"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        rows={maxDatasetPerPage}
        size="small"
        //showGridlines
        scrollable   
      >
        {dynamicColumns}
      </DataTable>
    </div>
  );
};

export default RawDatasetsTable;
